var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutWithContainer",
    [
      _c(
        "template",
        { slot: "header" },
        [
          _c(
            "ContentHeader",
            { attrs: { title: "Reports", bordered: false } },
            [
              _c("template", { slot: "actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.$modal.show("new-report")
                      },
                    },
                  },
                  [_vm._v("Create Report")]
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "vue-tabs",
        { ref: "tabs", on: { "tab-change": _vm.onTabChange } },
        [
          _c(
            "v-tab",
            { attrs: { id: "opportunities", title: "Opportunities" } },
            [_c("ReportTabOpportunities", { ref: "opportunities" })],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab",
            { attrs: { id: "madds", title: "MADDs" } },
            [_c("ReportTabMADDs", { ref: "madds" })],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "new-report",
            adaptive: true,
            height: "auto",
            maxHeight: 900,
          },
        },
        [
          _c(
            "form",
            {
              ref: "form",
              staticClass: "form",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  $event.stopPropagation()
                  return _vm.handleSubmit.apply(null, arguments)
                },
              },
            },
            [
              _c("h2", [_vm._v("Create Report")]),
              _vm._v(" "),
              _c("FormControlReportType", {
                attrs: { name: "type", resource: _vm.currentTab },
                model: {
                  value: _vm.formData.type,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "type", $$v)
                  },
                  expression: "formData.type",
                },
              }),
              _vm._v(" "),
              _vm.showSectors
                ? _c("FormControlSector", {
                    attrs: {
                      name: "sectors",
                      multiple: true,
                      "include-ancestors": false,
                    },
                    model: {
                      value: _vm.formData.sectors,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "sectors", $$v)
                      },
                      expression: "formData.sectors",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("FormControlDatepicker", {
                attrs: { name: "fromDate", label: "From date" },
                model: {
                  value: _vm.formData.fromDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "fromDate", $$v)
                  },
                  expression: "formData.fromDate",
                },
              }),
              _vm._v(" "),
              _c("FormControlDatepicker", {
                attrs: { name: "toDate", label: "To date" },
                model: {
                  value: _vm.formData.toDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "toDate", $$v)
                  },
                  expression: "formData.toDate",
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  class: {
                    btn: true,
                    "btn--action": true,
                    active: _vm.$wait.is("creating_report"),
                  },
                  attrs: { type: "submit" },
                },
                [
                  _vm.$wait.is("creating_report")
                    ? _c("Spinner", {
                        attrs: { height: 13, width: 13, color: "#ffffff" },
                      })
                    : _c("span", [_vm._v("Submit")]),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }